import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import img3 from "../../assets/images/terratraf/blocks.png";
import img2 from "../../assets/images/terratraf/desks.png";
import img4 from "../../assets/images/terratraf/stats.png";

class WhatWeDo extends Component {
  state = {
    features1: [

    ],
    features2: [
      { title: "Digital Marketing Solutions for Tomorrow" },
      { title: "Our Talented & Experienced Marketing Agency" },
      { title: "Create your own skin to match your brand" },
    ],
  };
  render() {
    return (
      <React.Fragment>
        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col lg="6" className="mt-2 mt-sm-0">
              <img src={img2} className="img-fluid" alt="" />
            </Col>
            <Col lg="6" className="mt-2 mt-sm-0">
              <div className="section-title">
                  <h1 className="title mb-3">
                    Площадки
                  </h1>
                  <p className="text-muted">
                    Под площадкой подразумевается сайт, на котором происходит показ рекламы. В рамках одной площадки может существовать несколько блоков - конкретных мест на сайте, имеющих определенный размер, выделенных для показа рекламы.
                  </p>
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col lg="6" md={{ order: 1 }} xs={{ order: 2 }} className="mt-2 mt-sm-0">
              <div className="section-title">
                <h1 className="title mb-3">
                  Блоки
                </h1>
                <p className="text-muted">
                  Блок - место на странице для отображения рекламы. Для того, чтобы начать использовать блок, сначала необходимо его добавить. Для этого надо вставить определенный код на страницу в место, где должна быть показана реклама. Подробнее об этом читайте в статье.
                </p>
                <a href="https://terratraf.readme.io/docs/ssp-howto" target="_blank" rel="noreferrer">Подробнее <i
                    className="uil uil-angle-right-b"></i></a>
              </div>
            </Col>
            <Col lg="6" md={{ order: 2 }} xs={{ order: 1 }} className="mt-2 mt-sm-0">
              <img src={img3} className="img-fluid" alt="" />
            </Col>
          </Row>
        </Container>

        <Container className="mt-100 mt-60">
          <Row>
            <Col md={4} xs={12} name="featurebox">
              <div className={"features text-center mt-4"}>
                <div className="image position-relative d-inline-block">
                  <i className={"uil uil-edit-alt h1 text-primary"} >
                  </i>
                </div>
                <div className="content mt-4">
                  <h5>Множество блоков</h5>
                  <p className="text-muted mb-0">Создание нескольких блоков позволяет разделять трафик для разных типов пользователей и / или для различных площадок, а также отслеживать статистику по каждому из них.</p>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12} name="featurebox">
              <div className={"features text-center mt-4"}>
                <div className="image position-relative d-inline-block">
                  <i className={"uil uil-vector-square h1 text-primary"} >
                  </i>
                </div>
                <div className="content mt-4">
                  <h5>Высокая скорость загрузки</h5>
                  <p className="text-muted mb-0">Достигается за счет асинхронного механизма реализации блоков, они не препятствуют загрузке страницы. </p>
                </div>
              </div>
            </Col>
            <Col md={4} xs={12} name="featurebox">
              <div className={"features text-center mt-4"}>
                <div className="image position-relative d-inline-block">
                  <i className={"uil uil-file-search-alt h1 text-primary"} >
                  </i>
                </div>
                <div className="content mt-4">
                  <h5>Пакетные операции</h5>
                  <p className="text-muted mb-0">
                    Вы можете производить операции сразу с несколькими блоками, скачав их настройки и загрузив измененные настройки в систему. Это позволит изменять большое количество блоков, не повторяя одни и те же операции вручную.
                    <a href="https://terratraf.readme.io/docs/ssp-пакетные-операции" target="_blank" rel="noreferrer"> Подробнее <i
                      className="uil uil-angle-right-b"></i></a>
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col lg="6" className="mt-5 mt-sm-0">
              <img src={img4} className="img-fluid" alt="" />
            </Col>
            <Col lg="6" className="mt-5 mt-sm-0">
              <div className="section-title">
                <h1 className="title mb-3">
                  Статистика
                </h1>
                <p className="text-muted">
                  Статистика площадки отображает совокупные данные по всем рекламным блокам сайта. Просмотр статистики доступен по датам, по площадкам и по блокам. Доступно отслеживание количества показов рекламных материалов и заглушки, доход от показа рекламы и др.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default WhatWeDo;
